import React from "react";

const scenarios = [
  {
    number: "01",
    title: "Customer service agents",
    text: "Resolve routine enquiries with policy-aware answers, connected knowledge and clear escalation to people when judgement is needed.",
  },
  {
    number: "02",
    title: "Sales and partner copilots",
    text: "Give commercial teams a faster route from account context to qualified follow-up, proposal preparation and partner coordination.",
  },
  {
    number: "03",
    title: "Knowledge operations",
    text: "Turn fragmented documents and operating knowledge into a governed, searchable resource for teams across regions.",
  },
  {
    number: "04",
    title: "Operations automation",
    text: "Coordinate recurring work across people and systems while keeping approvals, traceability and service quality visible.",
  },
];

export const AgentShowcase = ({ onOpenPage }) => {
  const openAgentPage = (event) => {
    if (!onOpenPage) return;
    event.preventDefault();
    onOpenPage("agent-platform");
  };

  return (
    <section id="agents" className="agent-showcase">
      <div className="container">
        <div className="agent-showcase-lead">
          <div>
            <span className="agent-kicker">SINGAPORE HQ · GLOBAL DELIVERY</span>
            <h2>Enterprise AI agents for work that has to get done.</h2>
          </div>
          <div className="agent-showcase-intro">
            <p>
              Goldly AI helps enterprises move from AI experimentation to agents
              that support real teams, real knowledge and real operating
              workflows across markets.
            </p>
            <a
              href="#/agent-platform"
              className="agent-text-link"
              onClick={openAgentPage}
            >
              Explore our Agent platform <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>

        <div className="agent-scenario-grid">
          {scenarios.map((scenario) => (
            <article className="agent-scenario" key={scenario.number}>
              <span>{scenario.number}</span>
              <h3>{scenario.title}</h3>
              <p>{scenario.text}</p>
            </article>
          ))}
        </div>

        <div className="agent-foundation">
          <span>Built for production</span>
          <p>
            Agent delivery is supported by our global model gateway, multi-cloud
            capacity, regional operations and enterprise security practices.
          </p>
          <a href="#services" className="agent-foundation-link">
            See the delivery foundation <span aria-hidden="true">↓</span>
          </a>
        </div>
      </div>
    </section>
  );
};
